import { render, staticRenderFns } from "./1_greetings.vue?vue&type=template&id=da9aed46&scoped=true&"
import script from "./1_greetings.vue?vue&type=script&lang=js&"
export * from "./1_greetings.vue?vue&type=script&lang=js&"
import style0 from "./1_greetings.vue?vue&type=style&index=0&id=da9aed46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9aed46",
  null
  
)

export default component.exports